import { Outlet } from 'react-router-dom';
import styled from '@emotion/styled';
import { APP_NAME } from '@myme/utils';
import { mq, webPalette } from 'src/themes';
import { Typography } from 'src/components/atoms';

const LayoutContainer = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
    180deg,
    ${webPalette.nonAuthGradient},
    ${props => props.theme.palette.background.default},
    ${webPalette.nonAuthGradientBlack}
  );
  padding-top: 2.5rem;
  overflow: hidden;
`;

const Logo = styled.img`
  height: 7.5rem;
  width: 7.5rem;
  margin-bottom: 1rem;
`;

const OutletContainer = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 40rem;
  min-height: calc(100vh - 15rem);
  padding: 1rem;

  ${mq.sm} {
    width: 90%;
    padding: 0;
  }
`;

export const NonAuthLayout = () => (
  <LayoutContainer>
    <Logo src='/LogoIcon.png' />
    <Typography variant='h5' sx={{ mb: 1.5 }}>
      {APP_NAME}
    </Typography>
    <OutletContainer>
      <Outlet />;
    </OutletContainer>
  </LayoutContainer>
);
